import { render, staticRenderFns } from "./Layout_Nav_User.vue?vue&type=template&id=45d71c10"
import script from "./Layout_Nav_User.vue?vue&type=script&lang=js"
export * from "./Layout_Nav_User.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports